export const setKbLink = (kbLink, elevInstance) => {
  elevInstance.setSettings({
    kbLink,
  });
};

export const InAppHelp = () => {
  // prettier-ignore
  // eslint-disable-next-line
  !function(e,l,v,i,o,n){e[i]||(e[i]={}),e[i].account_id=n;var g,h;g=l.createElement(v),g.type="text/javascript",g.async=1,g.src=o+n,h=l.getElementsByTagName(v)[0],h.parentNode.insertBefore(g,h);e[i].q=[];e[i].on=function(z,y){e[i].q.push([z,y])}}(window,document,"script","_elev","https://cdn.elev.io/sdk/bootloader/v4/elevio-bootloader.js?cid=","59c16ae1adf0d");

  if (window._elev) {
    window._elev.on('load', () => {
      // DE473926 - adding knowledge base in elevio produces "Open in new window" link in all articles
      // const kbLink = 'http://help.blazemeter.com';
      // setKbLink(kbLink, window._elev);
    });
  }
};
